  (function () {
    document.querySelectorAll('.tg').forEach(function (root) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


    // shower calculator
    var ms = root.querySelector('[data-tg-measure]');
    if (ms) {
      var refill = parseFloat(ms.getAttribute('data-refill')) || 1190;
      var shown = {};
      var fmt = function (n) { return Math.round(n).toLocaleString('en-GB'); };
      function tween(key, el, to, dec) {
        var from = shown[key] || 0, t0 = null, d = 600;
        shown[key] = to;
        if (reduce) { el.textContent = dec ? to.toFixed(dec) : fmt(to); return; }
        function st(ts) { if (!t0) t0 = ts; var p = Math.min((ts - t0) / d, 1), v = from + (to - from) * (1 - Math.pow(1 - p, 3));
          el.textContent = dec ? v.toFixed(dec) : fmt(v); if (p < 1) requestAnimationFrame(st); }
        requestAnimationFrame(st);
      }
      function calc() {
        var v = {};
        ms.querySelectorAll('[data-i]').forEach(function (i) {
          v[i.dataset.i] = parseFloat(i.value);
          i.style.setProperty('--p', ((i.value - i.min) / (i.max - i.min) * 100) + '%');
          ms.querySelector('[data-o="' + i.dataset.i + '"]').textContent = i.value;
        });
        var showers = v.wk * v.ppl * 52, mins = showers * v.min, litres = mins * 8;
        var carts = Math.max(1, Math.ceil(showers / 70));
        var pence = carts * refill / showers;
        tween('hours', ms.querySelector('[data-m="hours"]'), mins / 60);
        tween('litres', ms.querySelector('[data-m="litres"]'), litres);
        tween('chlorine', ms.querySelector('[data-m="chlorine"]'), litres * 0.5 / 1000, 1);
        tween('carts', ms.querySelector('[data-m="carts"]'), carts);
        tween('pence', ms.querySelector('[data-m="pence"]'), pence);
      }
      ms.querySelectorAll('[data-i]').forEach(function (i) { i.addEventListener('input', calc); });
      if (reduce || !('IntersectionObserver' in window)) calc();
      else { var mo = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { calc(); mo.disconnect(); } }, { threshold: .3 }); mo.observe(ms); }
    }

    root.querySelectorAll('[data-tg-split]').forEach(function (h) {
      var text = h.textContent.trim();
      h.setAttribute('aria-label', text);
      h.innerHTML = text.split(/\s+/).map(function (w, i) { return '<span class="w" aria-hidden="true"><span style="--wi:' + i + '">' + w + '</span></span>'; }).join(' ');
    });

    root.querySelectorAll('.tg-stats__row, .tg-ticks, .tg-steps__list, .tg-tools__grid, .tg-bundles__grid, .tg-spec__grid, .tg-faq__inner').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (el, i) { if (el.classList.contains('tg-rv')) el.style.setProperty('--d', (i * 0.1) + 's'); });
    });
    root.querySelectorAll('.tg-gallery__item').forEach(function (el, i) { el.style.setProperty('--d', (i * 0.08) + 's'); });

    function count(el) {
      var target = parseFloat(el.getAttribute('data-tg-count')), dec = parseInt(el.getAttribute('data-tg-dec') || '0', 10), start = null, dur = 1500;
      function step(ts) { if (!start) start = ts; var p = Math.min((ts - start) / dur, 1);
        el.textContent = (target * (1 - Math.pow(1 - p, 3))).toFixed(dec); if (p < 1) requestAnimationFrame(step); }
      el.textContent = (0).toFixed(dec); requestAnimationFrame(step);
    }

    var targets = root.querySelectorAll('.tg-rv, [data-tg-split], .tg-gauge, .tg-hero__media, .tg-core__viz, .tg-gallery__strip, .tg-steps__list, .tg-stat');
    if (reduce || !('IntersectionObserver' in window)) {
      root.classList.add('no-anim');
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        e.target.querySelectorAll('[data-tg-count]').forEach(function (c) { if (!c.dataset.done) { c.dataset.done = 1; count(c); } });
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (el) { io.observe(el); });

    var par = root.querySelector('[data-tg-parallax]');
    if (par) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          par.style.transform = 'translate3d(0,' + (Math.min(window.scrollY, 900) * 0.08) + 'px,0)';
          ticking = false;
        });
      }, { passive: true });
    }

    var strip = root.querySelector('[data-tg-drag]');
    if (strip) {
      var down = false, sx = 0, sl = 0;
      strip.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; sx = e.clientX; sl = strip.scrollLeft; strip.classList.add('is-drag'); });
      window.addEventListener('pointerup', function () { down = false; strip.classList.remove('is-drag'); });
      strip.addEventListener('pointermove', function (e) { if (down) strip.scrollLeft = sl - (e.clientX - sx); });
    }
  });
  })();
